module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-container ContractsAdd"
  }, [_c('form', {
    staticClass: "h-adr"
  }, [_c('p', {
    staticClass: "m-label"
  }, [_vm._v("新規追加")]), _vm._v(" "), _c('contract-form', {
    attrs: {
      "contract": _vm.contract,
      "watch": _vm.watch
    }
  }), _vm._v(" "), _c('btn', {
    staticClass: "u-btn u-btn--add",
    nativeOn: {
      "click": function($event) {
        return _vm.postcontract($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-contract-plus"
  }), _vm._v("contractを新規追加")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e352101c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Contracts/ContractsAdd.vue
// module id = 1476
// module chunks = 0